import algoliasearch from 'algoliasearch'

const algolia = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY)
const index = algolia.initIndex('events')

export default index
